import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState } from "react";

import { MenuItemWithIcon, HoverExtender, SubMenu, MenuItem } from "../styles";
import AllOrgs from "src/containers/filter/AllOrgs";
import Icon from "src/icons";

const OrgMenu = () => {
  const [orgMenu, setOrgMenu] = useState(false);

  return (
    <MenuItem
      handle-cy="change-org-li"
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={() => setOrgMenu(true)}
      onMouseLeave={() => setOrgMenu(false)}
    >
      <MenuItemWithIcon>
        <Icon type="change" />
        <span>{i18n.t(k.CHANGE_ORG)}</span>
      </MenuItemWithIcon>
      {orgMenu ? <HoverExtender /> : null}
      {orgMenu ? (
        <SubMenu>
          <AllOrgs />
        </SubMenu>
      ) : null}
    </MenuItem>
  );
};

export default OrgMenu;
